import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, PlayCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { api, V1 } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const EXAM_TYPES = ["LGS", "TYT", "AYT"];

export default function PastQuestions() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("LGS");
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`${V1}/past-exams?exam_type=${tab}`).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [tab]);

  const start = async (id) => {
    if (!user) { navigate("/giris"); return; }
    try {
      const { data } = await api.post(`${V1}/exam-sessions/start`, { past_exam_id: id });
      sessionStorage.setItem(`sano_session_${data.session_id}`, JSON.stringify(data));
      navigate(`/sinav/${data.session_id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Başlatılamadı");
    }
  };

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12" data-testid="past-questions-page">
      <div className="mb-10">
        <div className="overline text-accent mb-2">Arşiv</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Çıkmış Sorular</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl">
          LGS, TYT ve AYT geçmiş yıl sorularını yıl bazında çözün, çözümlerinizi analiz edin.
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-6">
          {EXAM_TYPES.map((t) => <TabsTrigger key={t} value={t} data-testid={`past-tab-${t}`}>{t}</TabsTrigger>)}
        </TabsList>
        {EXAM_TYPES.map((t) => (
          <TabsContent key={t} value={t}>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.length === 0 && <div className="text-muted-foreground p-16 col-span-3 text-center">Bu tür için arşiv boş.</div>}
              {items.map((e) => (
                <div key={e.id} className="p-6 rounded-xl border border-border bg-card">
                  <BookOpen className="h-6 w-6 text-accent mb-3" />
                  <div className="font-display font-bold text-lg">{e.title}</div>
                  <div className="text-sm text-muted-foreground mt-1">{e.question_count} soru</div>
                  <Button onClick={() => start(e.id)} className="w-full mt-4" variant="outline" data-testid={`start-past-${e.id}`}>
                    <PlayCircle className="h-4 w-4" /> Sorulara Başla
                  </Button>
                </div>
              ))}
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
